import React, { Component } from "react"
import Nav from '../../components/layout/nav/nav';
import Discussions from '../../components/layout/discussions/discussions';
import Util from "../../utils/utils";
import { Redirect } from "react-router-dom";
import axios from "axios";
import * as config from "../../config";
import ErrorModal from "../../components/layout/modal/error";

const NavUrls = [
	{
		id : 1,
		class : "active",
		name : "پلی لیست",
		link : '/playlist/'
	}
];

class PlayList extends Component
{


	constructor ( props )
	{
		super( props );

		this.state = {
			error : null,
			isLoaded : false,
			status : 200,
		};

	}

	getData ( token )
	{
		try
		{
			axios.post( config.api_url + "/playlist/", {}, {
				timeout : 30000,
				headers : {
					'Content-Type' : 'application/json',
					'Authorization' : token,
				}
			} ).then( res =>
			{
				if ( res.data.status )
				{
					let resData = res.data.data;

					this.setState( {
						isLoaded : true,
						status : 200,
						items : resData.playlists
					} );

					// if ( resData.last_item !== undefined &&  resData.last_item.title !== undefined && resData.last_item.title !== "" && resData.is_active )
					// {
					// 	let url = config.server_file_url + Util.encodeJwt( {
					// 		"item_id" : resData.last_item.id,
					// 		"exp" : parseInt( Date.now() / 1000 ) + ( 12 * 60 * 60 )
					// 	} );
					//
					// 	if ( resData.last_item.data_type === "0" )
					// 	{
					// 		dataService.setData( {
					// 			"name" : resData.last_item.title,
					// 			"isPlaying" : true,
					// 			"volumeStatus" : true,
					// 			"mediaRate" : 1,
					// 			"item_type" : 0,
					// 			"currentTime" : parseInt( resData.last_item.time ),
					// 			"item_id" : resData.last_item.id,
					// 			"url" : url
					// 		} );
					// 	}
					// 	else
					// 	{
					// 		dataService.setData( {
					// 			"name" : resData.last_item.title,
					// 			"isPlaying" : true,
					// 			"currentTime" : 0,
					// 			"volumeStatus" : true,
					// 			"item_id" : resData.last_item.id,
					// 			"item_type" : 1,
					// 			"mediaRate" : 1,
					// 			"url" : url,
					// 			"videoJsOptions" : {
					// 				autoplay : true,
					// 				controls : false,
					// 				responsive : false,
					// 				fluid : false,
					// 				playbackRates: [1, 1.25, 1.5, 1.75, 2],
					// 				fill : false,
					// 				sources : [ {
					// 					src : url,
					// 					type : 'video/mp4'
					// 				} ]
					// 			}
					// 		} );
					// 	}
					//
					// }


				}
				else
				{
					this.setState( {
						isLoaded : true,
						status : 401,
						error : {}
					} );
				}

			} ).catch( error =>
			{
				this.setState( {
					isLoaded : true,
					status : 401,
					error
				} );
			} );

		}
		catch ( error )
		{
			this.setState( {
				isLoaded : true,
				status : 401,
				error
			} );
		}

	}

	CheckToken ( token )
	{
		try
		{
			axios.post( config.api_url + "/account/refresh-token", {}, {
				timeout : 30000,
				headers : {
					'Content-Type' : 'application/json',
					'Authorization' : token,
				}
			} ).then( res =>
			{
				if ( res.data.status )
				{
					Util.setSession( "token", res.data.token );
				}

				const token = "Bearer " + Util.getSession( "token" );
				this.getData( token );

			} ).catch( error =>
			{

			} );

		}
		catch ( error )
		{

		}
	}


	componentDidMount ()
	{
		this.CheckToken( "Bearer " + Util.getSession( "token" ) )
	}

	componentDidUpdate ( prevProps: Readonly<P>, prevState: Readonly<S>, snapshot: SS ): void
	{
		Util.convertNumberToPersion( document.body );
	}

	handleRefresh = () =>
	{
		this.setState( ( oldstate ) => ( { ...oldstate, errorShow : false } ) );
		window.location.reload();
	};


	render ()
	{
		const token = Util.getSession( "token" );

		if ( !token )
			return <Redirect to="/login"/>;

		const { error, isLoaded, items } = this.state;

		if ( error )
		{
			return (
				<ErrorModal show={true} handleRefresh={this.handleRefresh} title="خطا!" buttonStatus={true} message="در دریافت اطلاعات مشکلی به وجود آمده است!" style={{
					"color" : "red",
					"fontSize" : "50px"
				}} iconName="fa-close"/>
			);
		}
		else if ( !isLoaded )
		{
			return (
				<ErrorModal show={true} handleRefresh={this.handleRefresh} title="لطفا منتظر بمانید" buttonStatus={false} message="در حال دریافت اطلاعات ..." style={{
					"color" : "white",
					"fontSize" : "50px"
				}} iconName="fa-refresh fa-spin"/>
			);
		}
		else
		{
			return (
				<>
					<main>
						<Nav urls={NavUrls}/>
						<Discussions showTitle={true} title="پلی لیست ها" url="/playlist/" courses={items}/>

					</main>
				</>
			)
		}
	}
}

export default PlayList;